import { render, staticRenderFns } from "./ForgeViewerWidget.vue?vue&type=template&id=2d50a2c0&scoped=true&"
import script from "./ForgeViewerWidget.vue?vue&type=script&lang=js&"
export * from "./ForgeViewerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50a2c0",
  null
  
)

export default component.exports